import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '@/assets/logo.png';

export function Footer(): React.JSX.Element {
    const navigate = useNavigate();

    const scrollToSection = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        } else if (window.location.pathname !== '/') {
            navigate('/');
            setTimeout(() => {
                document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
    };

    return (
        <footer className="bg-gray-900 text-white py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    <div className="col-span-1 md:col-span-2">
                        <div className="flex items-center mb-4">
                            <img src={logo} alt="List8.app Logo" className="h-16 w-auto brightness-0 invert" />
                        </div>
                        <p className="text-gray-400 max-w-sm">
                            Simple, powerful tools for real estate pros. We help you sell homes faster with AI.
                        </p>
                    </div>
                    <div>
                        <h4 className="font-bold mb-4">Services</h4>
                        <ul className="space-y-2 text-gray-400">
                            <li><button onClick={() => scrollToSection('pricing')} className="hover:text-white text-left">Virtual Staging</button></li>
                            <li><button onClick={() => scrollToSection('pricing')} className="hover:text-white text-left">Item Removal</button></li>
                            <li><button onClick={() => scrollToSection('pricing')} className="hover:text-white text-left">Day to Dusk</button></li>
                            <li><button onClick={() => scrollToSection('pricing')} className="hover:text-white text-left">Pricing</button></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="font-bold mb-4">Company</h4>
                        <ul className="space-y-2 text-gray-400">
                            <li><button onClick={() => navigate('/about')} className="hover:text-white text-left">About Us</button></li>
                            <li><button onClick={() => navigate('/contact')} className="hover:text-white text-left">Contact</button></li>
                            <li><button onClick={() => navigate('/privacy')} className="hover:text-white text-left">Privacy Policy</button></li>
                            <li><button onClick={() => navigate('/terms')} className="hover:text-white text-left">Terms of Service</button></li>
                        </ul>
                    </div>
                </div>
                <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-500">
                    <p>&copy; {new Date().getFullYear()} List8.app. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}
